import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "filter__active" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "filter__arr iconfont iarrow-down" }, null, -1)
const _hoisted_3 = { class: "filter__list" }
const _hoisted_4 = ["onClick"]

import { ref } from 'vue'

import { DocsView } from '@/models/doc'
import { DocsSortView } from '@/models/docs.sort'
import { assertNotNull } from '@/helpers/typing'


export default /*#__PURE__*/_defineComponent({
  __name: 'DocsSort',
  props: {
    view: null
  },
  setup(__props: any) {

const props = __props as {
  view: DocsView
};



const sortView = ref(new DocsSortView(props.view, true))

function hide(): void {
  assertNotNull(sortView.value).hide()
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["filter__order", { 'filter__order--active': sortView.value.visible }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (sortView.value.toggleMenu()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(["filter__icon iconfont", sortView.value.activeOptIcon])
      }, null, 2),
      _createTextVNode(_toDisplayString(sortView.value.displayedSortOptionName), 1)
    ]),
    _hoisted_2,
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortView.value.options, (opt) => {
            return (_openBlock(), _createElementBlock("li", {
              key: opt.name,
              class: "filter__item",
              onClick: _withModifiers(($event: any) => (opt.click()), ["prevent"])
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["filter__icon iconfont", opt.icon])
              }, null, 2),
              _createTextVNode(_toDisplayString(opt.name), 1)
            ], 8, _hoisted_4))
          }), 128))
        ], 512), [
          [_vShow, sortView.value.visible]
        ])
      ]),
      _: 1
    })
  ], 2)), [
    [_directive_click_outside, hide]
  ])
}
}

})